<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
        <vs-dropdown-item
             @click.stop="templateViewSidebar(params.data.push_template_id)" 
            >Preview</vs-dropdown-item>
          <vs-dropdown-item
          
           @click.stop="templateEditSidebar(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item
            @click="templateDeletePopup(params.data.push_template_id)"
            >Delete</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  mixins: [PermissionMiddleware],
  name: 'CellRendererAction',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    templateViewSidebar (editingObject) {
      this.params.colDef.filterParams.templateViewSidebar(editingObject)
    }, 
    templateEditSidebar (id) {
      this.params.colDef.filterParams.templateEditSidebar(id)
    },
    templateDeletePopup (id) {
      this.params.colDef.filterParams.templateDeletePopup(id)
    }
  }
}
</script>